module.exports = __webpack_public_path__ + "static/media/miranda copy.95b309ff.jpg";